import { render, staticRenderFns } from "./TrabalhoEditModal.vue?vue&type=template&id=93947486&scoped=true"
import script from "./TrabalhoEditModal.vue?vue&type=script&lang=js"
export * from "./TrabalhoEditModal.vue?vue&type=script&lang=js"
import style0 from "./TrabalhoEditModal.vue?vue&type=style&index=0&id=93947486&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93947486",
  null
  
)

export default component.exports